<template>
    <div id="learn-three" >
      <div class="background-learn background-steps z-index-10"></div>
      <div class="learn-three-desktop" v-if="$vuetify.breakpoint.smAndUp">
        <div class="absolute text-area z-index-10" :style="textareaPos" >
          <div class="absolute roboto-normal-18 mt-8 ml-6 clr-black-38 z-index-10">Общая информация</div>
        </div>
        <img class="absolute decor-zero z-index-10" src="@/assets/images/learn/Rectangle 403.png" :style="textareaPos">
        <img class="absolute decor-one z-index-10" src="@/assets/images/learn/Ellipse 92.png" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
        <div class="flex absolute information z-index-10" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
          <img class="absolute decor-two" src="@/assets/images/learn/robot_3.png" :class="{sm:$vuetify.breakpoint.sm}">
          <div class="absolute text" :class="{sm:$vuetify.breakpoint.sm}">
            <div class="roboto-normal-24 clr-black mt-xl-12 mt-lg-12 mt-md-12 mt-sm-2">Здесь ты можешь записывать общую информацию подраздела “{{sampleName}}”</div>
            <div class="flex-center pointer pt-6" @click="toStepFour()">
              <div class="roboto-normal-24 clr-white">Далее</div>
              <v-icon class="ml-1 opacity-max" x-large color="white">mdi-chevron-right</v-icon>
            </div>
            <LearnSkipButton/>
          </div>
        </div>
      </div>
      <div class="learn-three-mobile" v-else>
        <div class="absolute text-area z-index-10" :style="textareaPos">
          <div class="absolute roboto-normal-18 mt-8 ml-6 clr-black-38 z-index-10">Общая информация</div>
        </div>
        <!-- <img class="absolute decor-zero z-index-10" src="@/assets/images/learn/Rectangle 540.png" :style="textareaPos"> -->
        <!-- <img class="absolute decor-one z-index-10" src="@/assets/images/learn/robot_3_mobile.png"> -->
        <img class="absolute decor-two z-index-10" src="@/assets/images/learn/Ellipse 118.png">
        <div class="absolute text z-index-10">
          <div class="roboto-normal-18 clr-black-38 mt-4">Здесь ты можешь записывать общую информацию подраздела “{{sampleName}}”</div>
          <div class="flex-center pointer mt-12 pt-4" @click="toStepFour()">
            <div class="roboto-normal-24 clr-white">Далее</div>
            <v-icon class="ml-1 opacity-max" x-large color="white">mdi-chevron-right</v-icon>
          </div>
          <LearnSkipButton/>
        </div>
      </div>
      </div>
</template>

<script lang='ts'>
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'
import { mapGetters } from 'vuex'
    import LearnSkipButton from './LearnSkipButton.vue'

    export default Vue.extend({
        props: {
            // item: Object as PropType<Block>,
            sampleName: String
        },
        components: {
    LearnSkipButton,
        
        },
        data() {
            return {
                textareaPos: {left: '', top: '', width: '', height: ''},
                
            }
        },
        computed: {
            ...mapGetters(['themes']),
        },
        methods: {
            toStepFour() {
                this.$router.push("/theme/" + this.themes[this.themes.length-1].route_name + "/" + this.themes[this.themes.length-1].tasks[0].route_name + "?learn=4") 
            },
            updateTextareaPosition() {
                const el = document.querySelector('.t-textarea')
                const rect = el && el.getBoundingClientRect()
                if (rect) {                
                    this.textareaPos.left = Math.floor(rect.left) + 'px'
                    this.textareaPos.top = Math.floor(rect.top) + 'px'
                    this.textareaPos.width = Math.floor(rect.width) + 'px'
                    this.textareaPos.height = Math.floor(rect.height) + 'px'
                }
            }
        },
        mounted() {
            this.$nextTick(this.updateTextareaPosition)
        }
    })

    </script>

<style lang="scss" scoped>
 #learn-three {
    .learn-three-desktop {
      .text-area {
        background: #EEF8FF;
        box-shadow: 0px 1px 39px #FFFFFF;
        border-radius: 9px;
      }
      .decor-zero {
        margin-top: -345px;
        height:1050px !important;
      }
      .decor-one {
        top:470px;
        left:52%;
        &.lg {
          left:34%;
        }
        &.md {
          left:14%;
        }
        &.sm {
          left:20%;
          width:590px;
        }
      }
      .information {
        top:490px;
        left:52%;
        &.lg {
          left:34%;
        }
        &.md {
          left:14%;
        }
        &.sm {
          left:23%;
        }
        .decor-two {
          left:35px;
          &.sm {
            top:-20px;
            left:-10px;
            height:178px;
          }
        }
        .text {
          top:35px;
          left:330px;
          width:325px;
          &.sm {
            top:-10px;
            left:230px;
            width:280px;
          }
        }
      }
    }
    .learn-three-mobile {
      .text-area {
        background: #EEF8FF;
        box-shadow: 0px 1px 39px #FFFFFF;
        border-radius: 9px;
      }
      .decor-zero {
        width:100%;
        top:145px;
        height:245px;
      }
      .decor-one {
        top:426px;
        left:23%;
      }
      .decor-two {
        top:440px;
        left:-15%;
      }
      .text {
        top:510px;
        left:90px;
        width:220px;
      }
    }
  }
</style>
